
import React from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import Bet from 'src/shared/charts/bets/bet.jsx'
import VotingForm from './voting_form.jsx'
import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {
  Legend
} from 'recharts';
import { VelocityTransitionGroup, VelocityComponent } from 'velocity-react';
import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui';


const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },

});

export default function Voting({videoRoom, event, ...props}) {
  const classes = useStyles();
  const bets = useSelector(state => state.bets)
  const bettings = useSelector(state => state.bettings)
  
  console.log("bets", bets)
  return (
    <fieldset>
    <VelocityTransitionGroup component="div" enter={{animation: "slideDown"}} leave={{animation: "slideUp"}} >
      {_.map(_.filter(bets, (bet, betId) => bet.visible && !bet.archived && bet.event_id == event.id), (bet, betId) => {
        console.log("bet", betId, bet, bet.answer_stats)
        
        let betting = bettings.find((betting) => betting.bet_id == bet.id)
        let maximum = _.sum(Object.values(bet.answer_stats))
        let answers = _.map(bet.answer_stats, (amount, title) => { return { name: title, value: maximum > 0 ? + ((amount / maximum) * 100).toFixed(2) : +(100 / Object.keys(bet.answer_stats).length).toFixed(2) } })

        return (
          <Card key={"bet_container_" + betId} className="m-2 mr-xl-0" variant="outlined" square={true}>
            <CardContent>

              <Typography className={classes.title} color="textSecondary" gutterBottom>
                <span dangerouslySetInnerHTML={{ __html: bet.title.trim()}}/>
              </Typography>

              
              {(bet.show_results && (betting != null || bet.locked)) ? ( 
                  <>
                  <Bet colors={["#D2B48C","#48D1CC","#F08080", "#FFE4B5", "#32CD32","#BDBDBD"]} data={answers} bet={bet} height={300} >
                    <Legend/>
                    </Bet>
                  </>
              ) : (
                bet.locked ? (
                  <span>Diese Umfrage wird in Kürze freigegeben.</span>
                ) : (
                  betting ? (
                    <span>Vielen Dank für Ihre Teilnahme und viel Glück!</span>
                  ) : (
                    <VotingForm bet={bet}/>
                  )
                  
                )
              )}
              
            </CardContent>
          </Card>
        )
        })
      }
    </VelocityTransitionGroup>

    </fieldset>
  )
}
